import { AxiosInstance } from 'axios'
import { inject } from 'tsyringe'
import {
  httpToken,
  vueI18nToken
} from '~/constants/dependency-injection/tokens'
import { containerScoped } from '~/decorators/dependency-container'
import { CategoryId } from '~/models/category/types'
import { VueI18n } from '~/utils/nuxt3-migration'

@containerScoped()
export default class MapSearchService {
  constructor(
    @inject(httpToken) private http: AxiosInstance,
    @inject(vueI18nToken) private i18n: VueI18n
  ) {}

  public resultsTitle(
    isShowSeller: boolean,
    isMapSearch: boolean,
    categoryIds: (number | string)[],
    formatedNumber: any
  ): string {
    if (
      isShowSeller &&
      [CategoryId.VEHICLES, CategoryId.PARTS].some(c => categoryIds.includes(c))
    ) {
      return this.i18n.tc('view 1 dealer | {count} dealers', formatedNumber)
    } else if (isShowSeller && categoryIds.includes(CategoryId.XYMA)) {
      return this.i18n.tc(
        'view 1 seller | view {count} sellers',
        formatedNumber
      )
    } else if (isShowSeller && isMapSearch) {
      return this.i18n.tc('view 1 agent | {count} agents', formatedNumber)
    } else {
      return this.i18n.tc(
        'show 1 classified | show {count} classifieds',
        formatedNumber
      )
    }
  }
}
